import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from 'react';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { useLocale } from '../../../../contexts/localeContext';
import { IAppState } from "../../../../store/types";
import { useSelector } from "react-redux";
import { getCategoryFields } from "../../../../services/customFieldsService";
import { CustomFieldBuilder } from "../../../../containers/utilities/CustomFieldBuilder";
import { CategoryFieldGroup } from "../../../../models/CategoryFieldGroup";
import settingTypesBasicFields from "../../../../constants/setting-types-basic-fields";
import ActivityFrame from "../../../activity-frame/activity-frame";
import { WizardStepLayout } from '../../../wizard/wizard-summary-layout';

interface Props {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (discription: string) => void;
    supportedFields: CategoryFieldGroup[];
    setSupportedFields: React.Dispatch<React.SetStateAction<CategoryFieldGroup[]>>;
}

const UserDetailsStep: FC<Props> = ({ onBack, onNext, setSideBarStepDescription, supportedFields, setSupportedFields}) => {
    const { translate } = useLocale();
    const { values, isValid } = useFormikContext<any>();
    const formik = useFormikContext<any>();
    const siteId = useSelector((state: IAppState) => state.site.site.value);
    const customFieldBuilder = new CustomFieldBuilder(formik, translate);
    const defaultIds = [settingTypesBasicFields.Title.id, settingTypesBasicFields.Department.id, settingTypesBasicFields.Company.id];
    const defaultCardIds = [settingTypesBasicFields.First_Name.id, settingTypesBasicFields.Last_Name.id, settingTypesBasicFields.Display_Name.id, settingTypesBasicFields.Unique_Identifier.id];
    const [busy, setBusy] = useState(false);

    const getCustomFields = async() => {
        const customFields = await getCategoryFields(values.categoryTypeId);
        return customFields;
    }
    
    useEffect(() => {
        setBusy(true);
        getCustomFields()
        .then(fields => {setSupportedFields(fields)})
        .finally(() => {
            setBusy(false);
        });
    }, [])

    const isEnabled = () => {
        return isValid && values.name && values.uid;
    }

    const onLocalNext = (event: any) => {
        onNext({ ...event });
        setSideBarStepDescription(values.name);
    };

    const onLocalBack = (event: any) => {
        setSideBarStepDescription(translate.byKey(TranslationKeys.pending));
        setSupportedFields([]);
        onBack({ ...event });
    };

    return <WizardStepLayout onBack={onLocalBack} onNext={onLocalNext} nextDisabled={!isEnabled()}>
        <ActivityFrame busy={busy} className={`w-full ${busy ? 'mt-40' : 'flex flex-col flex-grow bg-white'}`}>
            <div className="mb-3 text-portal-blue-primary-shade2 text-xl font-semibold">{translate.byKey(TranslationKeys.userDetails)}</div>
            <div>
                <div className="flex flex-col">
                    {supportedFields.filter((fieldGroup) => fieldGroup.fields?.length > 0).map((fieldGroup) => {
                        return <>
                            {fieldGroup.fields
                                .reduce((formFields, field) => {
                                    if(field.isRequired || defaultIds.includes(field.columnId)) {
                                        return customFieldBuilder.buildFormField(formFields, field, undefined, undefined, siteId, undefined, true)
                                    }
                                    else if (defaultCardIds.includes(field.columnId)) {
                                        return customFieldBuilder.buildCardField(formFields, field)
                                    }
                                    return formFields;
                                }, new Array(0))
                                .map(fieldBundle => <div className="relative" style={{width: '98%'}}>{fieldBundle.length === 1
                                    ? fieldBundle[0].span
                                        ? fieldBundle[0].content
                                        : <>{fieldBundle[0].content}
                                            <div className="px-3"></div></>
                                    : fieldBundle.map(field => field.content)}</div>)}</>
                    })}
                </div>
            </div>
        </ActivityFrame>
    </WizardStepLayout>;
};

export default UserDetailsStep;